<script>
    import { Typography } from './'
    import SimplyCheck from '../Icons/custom/SimplyCheck.svelte'
    export let breakPoints = []
    export let current = 0
    export let scale = 1
    $: if (current >= breakPoints.length) {
        current = breakPoints.length - 1
    }
    $: if (current < 0) {
        current = 0
    }
</script>

<div style="zoom: {scale};">
    <div
        class="breakpoints"
        style={`padding: 0 calc(${50 / breakPoints.length / 2}% - 14px)`}
    >
        <span
            class="line"
            style={`width: calc(100% - ${50 / breakPoints.length}%)`}
        >
            <span
                class="progress colored"
                style={`width: ${(100 / (breakPoints.length - 1)) * current}%`}
            ></span>
        </span>
        {#each breakPoints as _, i}
            <i
                class={`${i <= current ? 'colored' : ''} ${i === current ? 'active' : ''}`}
            >
                {#if i === 0}
                    <SimplyCheck />
                {:else}
                    {i + 1}
                {/if}
            </i>
        {/each}
    </div>
    <div class="tags">
        {#each breakPoints as point, i}
            {@const isCurrent = i === current}
            {@const colored = i <= current}
            <Typography
                style={`padding: 0; margin: 0; text-align: center; width: ${50 / breakPoints.length}%; text-decoration: ${isCurrent ? 'underline' : 'none'}; font-weight: ${isCurrent ? 500 : 400}`}
                color={colored ? 'grey-800' : 'grey-300'}
                type="body">{point.label}</Typography
            >
        {/each}
    </div>
</div>

<style>
    div {
        width: 100%;
        display: flex;
        position: relative;
        flex-direction: column;
        justify-content: space-between;
        padding: 19px 0 14px 0;
        gap: 10px;
        height: fit-content;
    }
    div.breakpoints {
        height: 14px;
        align-items: center;
        /* padding: 0 10%; */
        margin: 0 0 8px 0;
        padding: 0;
        flex-direction: row;
    }
    div.tags {
        flex-direction: row;
        padding: 0;
        font-family: Roboto;
        font-size: 14px;
        font-weight: 500;
        line-height: 16px;
        letter-spacing: 0em;
        text-align: center;
    }
    i {
        width: 28px;
        height: 28px;
        display: flex;
        background: var(--color-grey-150);
        border: 2px solid var(--color-grey-300);
        position: relative;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        color: var(--color-grey-300);
        transition: all 0.2s ease-in-out;
        text-decoration: none;
        box-sizing: border-box;
        text-align: center;
        font-style: normal;
    }

    span.line {
        height: 2px;
        top: 6px;
        background: var(--color-grey-300);
        padding: 0;
        /* width: 100%; */
        position: absolute;
    }
    span.progress {
        margin: 0;
        display: block;
        position: relative;
        height: 100%;
    }
    span {
        transition: all 0.2s ease-in-out;
    }
    .colored {
        background: var(--color-brand-primary-01);
        border-color: var(--color-brand-primary-01);
        color: white;
    }
</style>
